import request from '@/utils/request'

export const statistic = (data) => {
  return request({
    url: '/fn/venue/manage/statistic',
    method: 'post',
    data,
  })
}

export const getList = (data) => {
  return request({
    url: '/fn/venue/manage/reserve/list',
    method: 'post',
    data,
  })
}

export const queryList = (data) => {
  return request({
    url: '/fn/venue/query/list',
    method: 'post',
    data,
  })
}
export const area = (data) => {
  return request({
    url: '/fn/venue/area',
    method: 'post',
    data,
  })
}
export const cancel = (data) => {
  return request({
    url: '/fn/venue/manage/cancel',
    method: 'post',
    data,
  })
}

export const save = (data) => {
  return request({
    url: '/fn/venue/save',
    method: 'post',
    data,
  })
}

export const deleteVenue = (data) => {
  return request({
    url: '/fn/venue/delete',
    method: 'post',
    data,
  })
}

export const type = (data) => {
  return request({
    url: '/fn/venue/type/all/type',
    method: 'post',
    data,
  })
}

export const deleteType = (data) => {
  return request({
    url: '/fn/venue/type/delete/type',
    method: 'post',
    data,
  })
}

export const saveType = (data) => {
  return request({
    url: '/fn/venue/type/save/type',
    method: 'post',
    data,
  })
}
